var map = {
	"./aep.png": 76989,
	"./ai.png": 27109,
	"./ar.png": 47222,
	"./canva.png": 8058,
	"./csv.png": 90343,
	"./default.png": 37160,
	"./doc.png": 81893,
	"./docx.png": 32697,
	"./eot.png": 10619,
	"./eps.png": 30609,
	"./fig.png": 50345,
	"./figma.png": 87363,
	"./gif.png": 97421,
	"./google_slides.png": 54505,
	"./heic.png": 88670,
	"./id.png": 52232,
	"./indd.png": 77010,
	"./indl.png": 24090,
	"./jpeg.png": 99781,
	"./jpg.png": 38394,
	"./key.png": 86482,
	"./mogrt.png": 59166,
	"./mov.png": 99361,
	"./mp4.png": 32646,
	"./otf.png": 58938,
	"./pdf.png": 96037,
	"./pdfx.png": 78041,
	"./png.png": 71530,
	"./pp.png": 67263,
	"./ppt.png": 26571,
	"./pptx.png": 96731,
	"./ps.png": 53700,
	"./psd.png": 86570,
	"./rar.png": 60064,
	"./slides.png": 82441,
	"./svg.png": 81653,
	"./ttf.png": 12577,
	"./txt.png": 78423,
	"./video-preview.png": 69709,
	"./video.png": 38246,
	"./woff.png": 75553,
	"./xls.png": 47384,
	"./xlsx.png": 43074,
	"./zip.png": 51106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41275;